// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"TabMenu_btn-primary__1s8dV","root":"TabMenu_root__1E_eW","is-active":"TabMenu_is-active__3ekFi"};